import { decrypt } from "../utils/cryptoHelper";

export const useUser = () => {
  return JSON.parse(decrypt(window.localStorage.getItem("token")));
};
